import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { addMiddleware } from 'redux-dynamic-middlewares';
import { store } from '@redux/store';
import onListViewPaint from 'pages/searchResults/redux/actions';
import { userProfileSlice } from './slices';
import { favoritesSessionStorageKey, pendingSavesSessionStorageKey } from '../constants/sessionStorageConstants';
import { selectFavorites, selectIsLoggedIn } from './selectors';
import updateSavedFavorites from '../components/favorites';

const actions = userProfileSlice.actions;
const listenerMiddleware = createListenerMiddleware();

// update the favorites data on session storage.
// this is done when a save / delete is successful.
listenerMiddleware.startListening({
  matcher: isAnyOf(actions.deleteFavoriteFullfilled, actions.saveFavoriteFulfilled),
  effect: async () => {
    const state = store.getState();
    const { favorites } = state.userProfile;
    sessionStorage.setItem(favoritesSessionStorageKey, JSON.stringify(favorites));
  },
});

// update the pending saves data on session storage.
// this is done when a save / delete hasn't been completed yet.
listenerMiddleware.startListening({
  matcher: isAnyOf(actions.saveFavorite, actions.deleteFavorite, actions.saveFavoriteFulfilled),
  effect: async () => {
    const state = store.getState();
    const { pendingSaves } = state.userProfile;

    sessionStorage.setItem(pendingSavesSessionStorageKey, JSON.stringify(pendingSaves));
  },
});

/* When the list view is paint, update the favorites if the user is login. */
listenerMiddleware.startListening({
  matcher: isAnyOf(onListViewPaint),
  effect: async () => {
    const state = store.getState();
    const isLoggedIn = selectIsLoggedIn(state);
    if (isLoggedIn) {
      const favorites = selectFavorites(state);
      updateSavedFavorites(favorites);
    }
  },
});

addMiddleware(listenerMiddleware.middleware);
